/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Catalog_RetryInputs */

const en_catalog_retry = /** @type {(inputs: Catalog_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retry`)
};

const zh_hans1_catalog_retry = /** @type {(inputs: Catalog_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重试`)
};

const pt_br2_catalog_retry = /** @type {(inputs: Catalog_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tentar de novo`)
};

const es_catalog_retry = /** @type {(inputs: Catalog_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reintentar`)
};

const fr_catalog_retry = /** @type {(inputs: Catalog_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réessayer`)
};

const de_catalog_retry = /** @type {(inputs: Catalog_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erneut versuchen`)
};

const ru_catalog_retry = /** @type {(inputs: Catalog_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Повторить`)
};

const it_catalog_retry = /** @type {(inputs: Catalog_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riprova`)
};

/**
* | output |
* | --- |
* | "Retry" |
*
* @param {Catalog_RetryInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const catalog_retry = /** @type {((inputs?: Catalog_RetryInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Catalog_RetryInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_catalog_retry(inputs)
	if (locale === "pt-BR") return pt_br2_catalog_retry(inputs)
	if (locale === "es") return es_catalog_retry(inputs)
	if (locale === "fr") return fr_catalog_retry(inputs)
	if (locale === "de") return de_catalog_retry(inputs)
	if (locale === "ru") return ru_catalog_retry(inputs)
	if (locale === "it") return it_catalog_retry(inputs)
	return en_catalog_retry(inputs)
});